export default __webpack_public_path__ + "static/media/filters.20045a12.svg";